module.exports = __webpack_public_path__ + "static/media/double_triangle_yellow.e486f7c0.svg";